<div class="content">
    <div class="modal-header">
        <span> {{ data.process }} </span>
        <button class="close-icon" (click)="closeModal()">
            <img src="../../../assets/images/cabruca/close-icon.svg" alt="close-icon">
        </button>
    </div>
    <div class="description-container">
        <span> {{ this.description }} </span>
    </div>
    <div class="chart-container">
        @if(data.stage != undefined || null) {
        <div class="titles">
            <span class="chart-title"> Emissão de Carbono </span>
            <span class="total"> Total: {{ data.stage.footPrint }} kg CO2 eq/t </span>
        </div>
        <google-chart [type]="chartType" [data]="chartData" [options]="chartOptions"> </google-chart>
        } @else {
        <span class="chart-title"> Dados não encontrados </span>
        }
    </div>

    <div class="advantages">
        <p class="title"> Vantagens do Processo Acelen </p>
        <ul>
            @for(li of liArray; track $index){
            <li> {{li}} </li>
            }
        </ul>
    </div>
</div>